import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import SkeletonLoading from "../Common/SkeletonLoading";
import {getAssetByCategories,getAllNLPByFilter } from "../../api/api_services";
import AssetsRating from "./assets_ratings";
import {useHistory} from "react-router-dom";
const ElementsAssets = (props) => {
  let [NlpAssest, setNlpAsset] = useState([]);
  let [headContent, setheadContent] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activebutton, setActivebutton] = useState({
    all: true,
    web: false,
    webandmobile: false,
    android: false,
    ios: false,
  });
  const [pageno, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const[activeTab,setactiveTab]=useState("all");
  const [assetsTypeID,setAssetsTypeID]=useState()
  let history=useHistory()
  useEffect(() => {
    let typeId;
    let assetstype=localStorage.hasOwnProperty("assets-type")&&JSON.parse(localStorage.getItem("assets-type"));
    assetstype.map((assets)=>{
      if(assets.type==="Elements"){
       
        typeId=assets.id
       
      }
    })
    getAllElements(typeId)
  }, []);


  const getAllElements = async(typeId) => {
    setAssetsTypeID(typeId)
    let response=await getAssetByCategories(typeId,pageno,pageSize)
    if (response?.data?.responseCode === 200 && response?.data?.message==="SUCCESS") {
      setNlpAsset(response?.data?.responseObject?.content);
      setIsLoading(false);
    } else {
      setNlpAsset([]);
      setIsLoading(false);
    }
  }

  // useEffect(() => {
  //   axios
  //     .get(
  //       "https://script.googleusercontent.com/a/macros/testyantra.com/echo?user_content_key=sCAW81GBheAY_OnblpeqpzP_0wkmu3brxJagU34bjnN2J7vtNfNglGdxZsvD7fRMtO9FbUC33FSdh1Wi-evUOHpsIUSBYxo8OJmA1Yb3SEsKFZqtv3DaNYcMrmhZHmUMi80zadyHLKAaie3BOJNjLK_YV2U5F_P7aAD8aA7uc1ccpDoXt3mxaZhl3rMd3cOsTgrTf9Shljqu0WIVXXwg4jy-F5eRfsXC-j8P8-8QxSJe38NGrHxxMDtBSHiycbjrLz5mj-hEBBsYZpTak_o22Q&lib=M2STiqZDcjpu21eUlkl_UA6rPthto8B-2"
  //     )
  //     .then((response) => {
  //       console.log(response);
  //       setheadContent(response?.data?.data);
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching assets data:", error);
  //       setIsLoading(false);
  //     });
  // }, []);
  const getElemtsByFilter=async(filter)=>{
    let response=await getAllNLPByFilter(filter,pageno,pageSize,assetsTypeID);
    if (response?.data?.responseCode === 200 && response?.data?.message==="SUCCESS") {
      setNlpAsset(response?.data?.responseObject?.content);
    } else {
      setNlpAsset([]);
    }
  }
  const handleActivebutton = (key) => {
    switch (key) {
      case "all": {
        setActivebutton({
          all: true,
          web: false,
          webandmobile: false,
          android: false,
          ios: false,
        });
        setactiveTab("all")
        getAllElements(assetsTypeID)
        break;
      }
      case "web": {
        setActivebutton({
          all: false,
          web: true,
          webandmobile: false,
          android: false,
          ios: false,
        });
        setactiveTab("web");
        getElemtsByFilter("Web")
        break;
      }
      case "webandmobile": {
        setActivebutton({
          all: false,
          web: false,
          webandmobile: true,
          android: false,
          ios: false,
        });
        setactiveTab("webandmobile")
        getElemtsByFilter("Web_And_Mobile")
        break;
      }
      case "android": {
        setActivebutton({
          all: false,
          web: false,
          webandmobile: false,
          android: true,
          ios: false,
        });
        setactiveTab("android")
        getElemtsByFilter("Android")
        break;
      }
      case "ios": {
        setActivebutton({
          all: false,
          web: false,
          webandmobile: false,
          android: false,
          ios: true,
        });
        setactiveTab("ios")
        getElemtsByFilter("iOS")
        break;
      }
      default: {
        setActivebutton({
          all: true,
          web: false,
          webandmobile: false,
          android: false,
          ios: false,
        });
        setactiveTab("all")
        getAllElements(assetsTypeID)
        break;
      }
    }
  };
  return (
    <section className="most_used_assets pb_30">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <h2 className="asset_head_two pt-50">
              {/* {isLoading ? <Skeleton width={300} /> : headContent[2]?.section} */}
              {isLoading ? <Skeleton width={300} /> : props?.data?.elemntsHeader}
            </h2>
            <div className="asset_head_line ml-90"></div>
          </div>
          <div className="col-lg-6">
            <div className="item_type pt-50">
              <div
                className={
                  activebutton.all
                    ? "items_type_asset_active"
                    : "items_type_asset"
                }
                onClick={() => {
                  handleActivebutton("all");
                }}
              >
                All items
              </div>
              <div
                className={
                  activebutton.web
                    ? "items_type_asset_active"
                    : "items_type_asset"
                }
                onClick={() => {
                  handleActivebutton("web");
                }}
              >
                Web
              </div>
              <div
                className={
                  activebutton.webandmobile
                    ? "items_type_asset_active"
                    : "items_type_asset"
                }
                onClick={() => {
                  handleActivebutton("webandmobile");
                }}
              >
                Web & Mobile
              </div>
              <div
                className={
                  activebutton.android
                    ? "items_type_asset_active"
                    : "items_type_asset"
                }
                onClick={() => {
                  handleActivebutton("android");
                }}
              >
                Android
              </div>
              <div
                className={
                  activebutton.ios
                    ? "items_type_asset_active"
                    : "items_type_asset"
                }
                onClick={() => {
                  handleActivebutton("ios");
                }}
              >
                iOS
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <p className="asset_head_des">
              {isLoading ? (
                <Skeleton width={900} />
              ) : (
                //  headContent[2]?.description
                 props?.data?.elementDescription
                
              )}
            </p>
          </div>
        </div>
        <div className="row pr_40 pl_40">
          {isLoading ? (
            <>
              <div>
                {" "}
                <SkeletonLoading itemCount={4} />
              </div>
            </>
          ) : (
            <>
              {NlpAssest?.slice(0, 7).map((data) => (
                <div className="col-lg-3 pl-30 pr_30 mt_50">
                  <div className="used_asset_box" 
                  // onClick={()=>{history.push(`/elements-description?id=${data.id}`)}}
                  onClick={()=>{history.push(`/elements-list?id=${data.id}`)}}
                  >
                    <div className="sce_btn">
                      <div className="asset_type">
                        <img
                          src={require("../../img/assets/excel.svg").default}
                          alt="excel"
                        />
                      </div>
                    </div>
                    <h3 className="mt-2 asset_type_head">{data.title}</h3>
                    <h4 className="asset_des ml-3 mr-3 mt_20">
                      {data.shortDescription}
                    </h4>
                    <div className="ml-3 mt-1 star_rating">
                      <AssetsRating rating={data?.rating}/>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          {
           NlpAssest?.length>7 && ( <div className="col-lg-3 pl-30 pr_30 mt_50">
           <div className="used_asset_box" onClick={()=>{history.push(`/elements?key=${activeTab}`)}}>
             <div className="text-center">
               <div>
                 <h3 className="view_all_txt mt_60">View All</h3>
               </div>
             </div>
           </div>
         </div>)
          }
         
        </div>
      </div>
    </section>
  );
};

export default ElementsAssets;
